<template>
  <div class="result-bside">
    <div class="result-bside-container container">
      <div class="result-bside-header">
        <div class="result-bside-header__cell">
          <img class="result-bside-header-bside" alt="lado B" src="@/assets/images/lado-b.png" />
          <h2>Dos tributos que pagamos</h2>
          <p>O sistema tributário brasileiro tem uma grande injustiça!</p>
        </div>

        <div class="result-bside-header__cell">
          <h3>
            <span><b>{{equalIncome}}%</b> de pessoas têm renda igual ou </span>
            <span>maior que você, e você contribui com <b>{{totalTaxPayed}}%</b> de </span>
            <span>sua renda em impostos.</span>
          </h3>
        </div>
      </div>

      <div class="result-bside-chart">
        <strong class="result-bside-chart-title">
          <span>Quanto da sua renda vai para </span>o pagamento de impostos
        </strong>

        <result-chart />
      </div>

      <div class="result-bside-explanation">
        <div class="result-bside-explanation__text">
          <p>A média de contribuição com impostos realizada pela população brasileira é de 19% da renda.</p>
          <p>Porém, as pessoas no 5% com menor renda (entre R$ 265 e R$ 570) contribuem proporcionalmente mais, pois elas dedicam, em média, 28% de sua renda ao pagamento de impostos. Nessa faixa de renda estamos falando dos impostos sobre consumo, porque essas pessoas são isentas do imposto de renda. Mas há pessoas nesta faixa de renda que também pagam impostos sobre propriedade, como IPVA e IPTU.</p>
          <p>Por outro lado, as pessoas no 0.2% de renda mais alta do país (renda média de R$ 175 mil) contribuem com impostos muito abaixo da média, com apenas 7% de sua renda.</p>
        </div>

        <ul class="result-bside-explanation__facts">
          <li class="result-bside-explanation__facts-title">Você sabia?</li>
          <li>
            <svg class="result-bside-explanation__facts-icon">
              <use xlink:href="#icon-lamp--green" />
            </svg>
            Se as pessoas no 0,2% contribuíssem com 19% da sua renda para pagamento de impostos, como faz o restante da população, seria possível:
          </li>
          <li>a. Aumentar em 45% a quantidade de estudantes na educação fundamental e de pessoas atendidas no SUS;</li>
          <li>b. E também aumentar em 30% os metros quadrados de vias pavimentadas, os quilos de lixo coletados e os pontos de iluminação instalados;</li>
        </ul>
      </div>
    </div>

    <button class="cta-scrollbutton" href="#">
      Conheça mais sobre essa realidade e o que você pode fazer para mudá-la

      <span class="cta-scrollbutton-icon">
        <svg>
          <use xlink:href="#icon-arrow-down"></use>
        </svg>
      </span>
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import Chart from '@/components/Result/Chart.vue';

export default {
  computed: {
    ...mapState(['income']),
    equalIncome() {
      return `${this.income.data.total_equalitty}`.replace('.', ',');
    },
    totalTaxPayed() {
      return Math.round(this.income.data.proportion_income_taxes * 100);
    },
  },
  components: {
    'result-chart': Chart,
  },
};
</script>

<style lang="scss">
.result-bside {
  position: relative;
  width: 100%;
  padding: rem-calc(120 0 120 0);

  background-color: $minsk;

  @media #{$large-up} {
    padding: rem-calc(150 0 130 0);
  }
}

.result-bside-header {
  margin-bottom: rem-calc(40);

  @media #{$large-up} {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }
}

.result-bside-header__cell {
  & + & {
    margin-top: rem-calc(30);
  }

  &:last-child {
    margin-bottom: rem-calc(60);
  }

  h2 {
    margin: rem-calc(0 0 20 0);
    color: $white;
    font-size: rem-calc(23);
    font-family: $font-family--header;
  }

  h3 {
    margin: 0;
    color: $white;
    font-size: rem-calc(23);
    font-family: $font-family--header;

    line-height: rem-calc(35);

    span {
      @media #{$medium-up} {
        display: block;
      }
    }

    b {
      color: $turmeric;
    }
  }

  p {
    margin: 0;

    color: $white;
    font-size: rem-calc(16);
    line-height: rem-calc(24);
  }
}

.result-bside-header-bside {
  width: 100%;
  max-width: rem-calc(345);
  margin-bottom: rem-calc(15);
}

.result-bside-chart {
  position: relative;
  margin-bottom: rem-calc(30);

  @media #{$medium-up} {
    margin-bottom: rem-calc(100);
  }
}

.result-bside-chart-title {
  position: relative;

  display: block;
  padding-left: rem-calc(30);
  margin-bottom: rem-calc(35);

  color: $white;
  font-size: rem-calc(15);
  font-weight: 600;
  line-height: rem-calc(20);

  &:before {
    content: '';
    position: absolute;

    top: 50%;
    left: 0;

    height: rem-calc(3);
    width: rem-calc(25);
    background-color: $turmeric;
  }

  span {
    display: block;
  }
}

.result-bside-explanation {
  @media #{$medium-up} {
    display: flex;
    align-items: flex-start;
  }
}

.result-bside-explanation__text {
  @media #{$medium-up} {
    margin-right: rem-calc(30);
  }

  @media #{$large-up} {
    margin-right: rem-calc(65);
  }

  p {
    margin: rem-calc(0 0 20 0);

    color: $white;
    font-size: rem-calc(16);
    line-height: rem-calc(24);
  }
}

.result-bside-explanation__facts {
  width: 100%;
  max-width: rem-calc(580);

  margin-top: rem-calc(40);
  padding: rem-calc(25);

  flex-shrink: 0;
  border-radius: rem-calc(20);
  background-color: #47236c;

  @media #{$medium-up} {
    max-width: rem-calc(375);
    margin-top: 0;
  }

  li {
    position: relative;
    padding-left: rem-calc(55);
    margin-bottom: rem-calc(20);

    color: $white;
    font-size: rem-calc(16);
    line-height: rem-calc(20);

    &:last-child {
      margin-bottom: 0;
    }
  }

  .result-bside-explanation__facts-title {
    font-size: rem-calc(20);
  }
}

.result-bside-explanation__facts-icon {
  position: absolute;
  top: 0;
  left: 0;

  width: rem-calc(35);
  height: rem-calc(35);
}

.result-bside-explanation__facts-title {
  font-weight: normal;
  font-family: $font-family--header;
}
</style>
